import axios from 'axios'
import store from '../../store'
import router from '../../router'
import { mixin } from './mixin'

export const configParams = {
    data: function() {
		return {
            params: [],
            newParam: {},
            isReady: false,
            editIndex: -1,
            editName: '',
            editedParam: {},
            defaultParams: [],
            units: [],
            configId: '',
            configName: '',
            pgVersion: '',
            allowedVersions: '',
            searchText: '',
            showAutocompleteParam: false
        }
    },

    mixins: [mixin],

    mounted: function() {

        const vc = this;

        if(!$('#loader').hasClass('show'))
            $('#loader').fadeIn()

        $(document).on('focus', 'tr.newParam input', function() {
            $(this).parents('tr').find('.focus').removeClass('focus')
            $(this).parents('td').addClass('focus')
        });

        $(document).on('blur','.comment textarea', function(){
            $(this).parents('td').removeClass('focus')
        })

        onmousemove = function (e) {

            if( (window.innerWidth - e.clientX) > 420 ) {
                $('#tooltip').css({
                    "top": e.clientY+20,
                    "right": "auto",
                    "left": e.clientX+20
                })
            } else {
                $('#tooltip').css({
                    "top": e.clientY+20,
                    "left": "auto",
                    "right": window.innerWidth - e.clientX + 20
                })
            }
        }

        $(document).on('mouseenter', 'tr td', function(){
            var c = $(this).find('.tooltipText');

            if(c.hasClass('error')) {
                var parentWidth = $('.tooltipText.error').parent().width();
                 $('#tooltip .info').text(c.text());
                $('#tooltip').addClass('show');
                $('#tooltip').addClass('error').width(parentWidth - 70);
            } else if( (c.width() > c.parent().width()) && !$(this).parent().hasClass('edit')) {
                $('#tooltip .info').text(c.text());
                $('#tooltip').addClass('show');
            }

        })

        $(document).on('mouseenter', '#defaultParams.shared tr td', function(){
            var c = $(this).find('.tooltipText');

            if(c.width() > c.parent().width()) {
                $('#tooltip .info').text(c.text());
                $('#tooltip').addClass('show');
            };

            if(c.hasClass('error')) {
                var parentWidth = $('.tooltipText.error').parent().width();
                 $('#tooltip .info').text(c.text());
                $('#tooltip').addClass('show');
                $('#tooltip').addClass('error').width(parentWidth - 70);
            }

        })

        $(document).on('mouseleave', 'tr td, [data-tooltip].show', function(){
            $('#tooltip .info').text('');
            $('#tooltip').removeClass('show error').width('');
        })

        $(document).on('mouseenter', '[data-tooltip]', function(){
            $('#tooltip .info').html($(this).data('tooltip'));
            $('#tooltip').addClass('show');
            $(this).addClass('show');
        })

        $(document).click(function(event) {
            var $target = $(event.target);

            if(!$target.closest('#customParams table').length && (vc.$route.name !== 'ValidateConfig')) {
                if(vc.editIndex != -1)
                    vc.setParam(vc.editIndex, false, true)
                else if (vc.editName.length)
                    vc.setParamByName(vc.editName)
            }
        });

        // Detect keyboard input
        document.addEventListener("keydown", event => {
            if( ((vc.editIndex != -1) && !vc.newParam.hasOwnProperty('name')) || (!vc.isSet(vc.editName)) ) { // Default params
                switch(event.keyCode) {
                    case 13: // Save on ENTER
                        event.preventDefault();
                        if(vc.editIndex != -1)
                            vc.setParam(vc.editIndex)
                        else
                            vc.setParamByName(vc.editName)
                        
                        $('.fullValue, .comment textarea').blur()
                        break;
                    case 27: // Cancel on ESC
                        event.preventDefault();
                        vc.cancelEdit()
                        $('.searchBar').removeClass('open').removeClass('focus')
                        $('.searchBar a.search.closeSearch').removeClass('closeSearch').text('Search')
                        $('.fullValue, .comment textarea').blur()
                        break;
                }
            } else if (vc.newParam.hasOwnProperty('name')){ // Custom param
                switch(event.keyCode) {
                    case 13: // Save on ENTER
                        event.preventDefault();
                        if(!$(event.target).parent('li').hasClass('active')) // If not autocomplete param
                            vc.setParam(0,true)
                        else {
                            vc.newParam.name = $(event.target).text().trim()
                            $('#newParam').focus()
                        }
                        $('.fullValue, .comment textarea').blur()
                        break;
                    case 27: // Cancel on ESC
                        event.preventDefault();
                        vc.cancelEdit(true)
                        $('.fullValue, .comment textarea').blur()
                        break;
                }
            }
        })

         document.addEventListener("keypress", event => {
            if( (event.key == '/') && ($(event.target).prop('id') != 'customKeyword')  && !$(event.target).parents('tr').length) {
                if(!$('.searchBar').hasClass('open')) {
                    $('a.search').click()
                    //$('#customKeyword').val('')
                }
                $('#customKeyword').focus()
                event.preventDefault()
                return false
            }
        })
    },

    computed: {
        configs () {
            const vc = this;

            if( ['ValidateConfig', 'PublicTuningGuide'].includes(vc.$route.name) ) {
                store.commit('setConfigs', [{
                    configId: 'tmp',
                    name: 'Untitled Configuration'
                }]);

                vc.configId = 'tmp'
                vc.configName = 'Untitled Configuration'

            } else if (!vc.isReady && store.state.authToken.length) {
                axios
                .get(process.env.VUE_APP_API_URL+'/configs/'+vc.$route.params.id)
                .then(function(response){
                    vc.configId = vc.$route.params.id
                    vc.configName = response.data.name
                    vc.pgVersion = response.data.pgVersion
                    
                    if(!store.state.configs.length)
                        store.commit('setConfigs', [response.data])
                })
                .catch(function(err) {
                    if(err.response.status != 401)
                        console.log(err);
                });
            } else if (vc.$route.name == 'PublicConfigParams') {
                axios
                .get(process.env.VUE_APP_API_URL+'/public/configs/'+vc.$route.params.id)
                .then(function(response){
                    vc.configName = response.data.name
                    vc.pgVersion = response.data.pgVersion
                    vc.configId = vc.$route.params.id
                    
                    if(!store.state.configs.length)
                        store.commit('setConfigs', [response.data])
                })
                .catch(function(err) {
                    if(err.response.status != 401)
                        console.log(err);
                });
            }

            if(!vc.isReady)
                vc.fetchData()

            return store.state.configs
        },

        sortedParams() {
            this.params.sort((a,b) => {
                if( a.name < b.name )
                    return -1
                else
                    return 1;

                return 0;
            });

            return this.params
        },

        defaultCount() {
            const vc = this
            var customCount = 0;

            vc.params.forEach(function(param){
                if(param.name.includes('.'))
                    customCount++
            })
            return vc.defaultParams.length - vc.params.length + customCount
        },

        validateConfig() {
            return (this.$route.name == 'ValidateConfig')
        },

        isPublic() {
            return (this.$route.name.includes('Public'))
        },

        searchNewParam() {
            return (this.newParam.hasOwnProperty('name') && this.newParam.name.length && (document.activeElement === document.getElementById('newParam')))
        }

    },

    methods: {
        removeLetters(octal = false) {
            if(octal) {
                if(!String.fromCharCode(event.keyCode).match(/[\d]/) || (event.target.value.length > 3))
                    event.preventDefault();
                } else if ((String.fromCharCode(event.keyCode) !== '.') && (!String.fromCharCode(event.keyCode).match(/[\-?(\d+\.?\d*|\d*\.?\d+)]/))) {
                event.preventDefault();
            }


            //event.target.value = event.target.value.replace(/[^\d]/g, '').substring(0,4)
        },

        forbiddenPopUp() {
            if(this.$route.name == 'ValidateConfig') {
                this.popUp('Attention','<p>You must <a href="' + this.loginUrl + '">login</a> or <a href="' + this.loginUrl + '">signup</a> to edit this configuration</p>')
            }
        },

        getParamDefault(param) {
            return this.defaultParams.find(p => ( param == p.name ) )
        },

        fetchData(scrollToParam = false) {
            const vc = this

            if(vc.$route.name == 'ValidateConfig') {
                vc.params = store.state.demoConfig.params
                vc.pgVersion = store.state.demoConfig.version

                if(!vc.allowedVersions.length) {
                    store.state.demoConfig.allowedVersions.forEach(function(v, i){
                        if(i==0)
                            vc.allowedVersions = v
                        else if(i < (store.state.demoConfig.allowedVersions.length - 1))
                            vc.allowedVersions += ', ' + v
                        else
                            vc.allowedVersions += ' and ' + v
                    })
                }

                // Save config information for later use
                vc.storeTmpConfig()

                if(!vc.isReady) {

                    // Get version specific units if not already loaded
                    if(typeof store.state.units[vc.pgVersion] !== 'undefined') {
                        vc.units = store.state.units[vc.pgVersion]
                    } else {
                        axios.get(process.env.VUE_APP_API_URL+'/docs/units/'+vc.pgVersion)
                        .then( function(response){
                            store.commit('setUnits', { version: vc.pgVersion, units: response.data.units })
                            vc.units = store.state.units[vc.pgVersion]
                        }).catch(function(err) {
                            if(err.response.status != 401)
                                console.log(err);
                        });
                    }

                    // Get version specific doc if not already loaded
                    if(typeof store.state.defaultParams[vc.pgVersion] !== 'undefined') {
                        vc.defaultParams = store.state.defaultParams[vc.pgVersion]
                    } else {
                        axios.get(process.env.VUE_APP_API_URL+'/docs/parameters/'+vc.pgVersion)
                        .then( function(response){
                            store.commit('setDefaultParams', { version: vc.pgVersion, params: response.data.params })
                            vc.defaultParams = store.state.defaultParams[vc.pgVersion]
                        }).catch(function(err) {
                            if(err.response.status != 401)
                                console.log(err);
                        });
                    }
                    vc.isReady = true
                    setTimeout(function(){
                        $('#loader').fadeOut().removeClass('show')
                        vc.popUp('NOTICE','<p>Your configuration has been analyzed successfuly.<br/>You can browse it here alongside documentation on each param;<br/>or <a href="' + vc.loginUrl + '">login</a> or <a href="' + vc.loginUrl + '">signup</a> to edit the configuration.</p>')
                    },1000)
                }


            } else if ( (store.state.authToken.length || (vc.$route.name == 'PublicConfigParams') ) && (vc.$route.name != 'PublicTuningGuide')) {

                axios
                .get(process.env.VUE_APP_API_URL + ((vc.$route.name == 'PublicConfigParams') ? '/public' : '') + '/configs/'+vc.$route.params.id+'/postgresql.conf', {
                    headers: {
                        'Authorization': 'Bearer '+store.state.authToken
                    }
                })
                .then( function(response){
                    vc.params = response.data.hasOwnProperty('params') ? response.data.params : []
                    vc.pgVersion = response.data.version

                    if(response.data.hasOwnProperty('allowedVersions')) { 
                        response.data.allowedVersions.forEach(function(v, i){
                            if(i==0)
                                vc.allowedVersions = v
                            else if(i < (response.data.allowedVersions.length - 1))
                                vc.allowedVersions += ', ' + v
                            else
                                vc.allowedVersions += ' and ' + v
                        })
                    }

                    // Get version specific units if not already loaded
                    if(typeof store.state.units[vc.pgVersion] !== 'undefined') {
                        vc.units = store.state.units[vc.pgVersion]
                    } else if (vc.pgVersion.length) {
                        axios.get(process.env.VUE_APP_API_URL+'/docs/units/'+vc.pgVersion)
                        .then( function(response){
                            store.commit('setUnits', { version: vc.pgVersion, units: response.data.units })
                            vc.units = store.state.units[vc.pgVersion]
                        }).catch(function(err) {
                            if(err.response.status != 401)
                                console.log(err);
                        });
                    }

                    // Get version specific doc if not already loaded
                    if(typeof store.state.defaultParams[vc.pgVersion] !== 'undefined') {
                        vc.defaultParams = store.state.defaultParams[vc.pgVersion]
                    } else if (vc.pgVersion.length) {
                        axios.get(process.env.VUE_APP_API_URL+'/docs/parameters/'+vc.pgVersion)
                        .then( function(response){
                            store.commit('setDefaultParams', { version: vc.pgVersion, params: response.data.params })
                            vc.defaultParams = store.state.defaultParams[vc.pgVersion]
                        }).catch(function(err) {
                            if(err.response.status != 401)
                                console.log(err);
                        });
                    }

                    // Check if cloning is requested
                    if(window.location.search) {
                        let urlParams = new URLSearchParams(window.location.search)

                        if(urlParams.get('clone'))
                            vc.cloneConfig()
                    }
                    

                    if(scrollToParam) {
                        vc.params.forEach(function(item, i){
                            if(item.name == vc.editName) {
                                setTimeout(function() {
                                    $('#customParams').animate({scrollTop: $("#custom-"+vc.editName).offset().top - $('#customParams tbody').offset().top})
                                },100)
                                return false
                            }
                        })
                    }

                    if(vc.$route.name == 'TuningGuide')
                        vc.tuningLevel = vc.getTuningLevel(vc.$route.params.id)
                    vc.isReady = true

                }).catch(function(err) {

                    if(err.response && (err.response.status == 404) && (vc.$route.name == 'PublicConfigParams')) {
                        vc.popUp('Unknown Request','The requested resource could not be found,<br/>please make sure the configuration exists and try again');
                        router.push('/manage')
                    }
                    
                    console.log(err);
                })


                setTimeout(function(){
                    $('#loader').fadeOut().removeClass('show')

                    // Remove tab index and set _blank links on docs
                    $('.descText a').prop('tabindex','-1').prop('target','_blank')
                },2000)
            } else if (vc.$route.name == 'PublicTuningGuide') {

                if(!vc.isReady) {
                    vc.pgVersion = '17' // Default version for public tuning guide

                    // Get version specific units if not already loaded
                    if(typeof store.state.units[vc.pgVersion] !== 'undefined') {
                        vc.units = store.state.units[vc.pgVersion]
                    } else {
                        axios.get(process.env.VUE_APP_API_URL+'/docs/units/'+vc.pgVersion)
                        .then( function(response){
                            store.commit('setUnits', { version: vc.pgVersion, units: response.data.units })
                            vc.units = store.state.units[vc.pgVersion]
                        }).catch(function(err) {
                            if(err.response.status != 401)
                                console.log(err);
                        });
                    }

                    // Get version specific doc if not already loaded
                    if(typeof store.state.defaultParams[vc.pgVersion] !== 'undefined') {
                        vc.defaultParams = store.state.defaultParams[vc.pgVersion]
                    } else {
                        axios.get(process.env.VUE_APP_API_URL+'/docs/parameters/'+vc.pgVersion)
                        .then( function(response){
                            store.commit('setDefaultParams', { version: vc.pgVersion, params: response.data.params })
                            vc.defaultParams = store.state.defaultParams[vc.pgVersion]
                        }).catch(function(err) {
                            if(err.response.status != 401)
                                console.log(err);
                        });
                    }
                    
                    vc.isReady = true

                    if (!('tmpNotice' in localStorage)) {
                        vc.notify('<p>This configuration is temporary, if you want to save any changes for later use, please <a href="' + vc.loginUrl + '">login</a> or <a href="' + vc.loginUrl + '">signup</a>.</p>', true, 'notice', 10000)
                        localStorage.tmpNotice = true
                    }

                    setTimeout(function(){
                        $('#loader').fadeOut().removeClass('show')
                    },1000)
                }

            }

            vc.newParam = {}

        },

        deleteParam(index) {
            const vc = this;

            if(vc.$route.name == 'ValidateConfig') {
                vc.forbiddenPopUp()
            } else {
                var param = vc.params[index];

                //console.log(param)

                const p = {
                    name: param.name,
                    restoreDefault: true
                }

                axios
                .patch(process.env.VUE_APP_API_URL+'/configs/'+this.$route.params.id+'/postgresql.conf', {params: [p]}, {
                    headers: {
                        'Authorization': 'Bearer '+store.state.authToken
                    }
                })
                .then( function(response){
                    vc.params.splice(index, 1);
                }).catch(function(err) {
                    console.log(err);
                });
            }
        },

        setDefault(index){
            const vc = this;

            if(vc.$route.name == 'ValidateConfig') {
                vc.forbiddenPopUp()
            } else {
                var param = vc.params[index];
                var defaultValue = vc.getParamDefault(param.name);

                const p = {
                    name: param.name,
                    setting: {
                        value: defaultValue.hasOwnProperty('default') ? defaultValue.default : ''
                    },
                    comment: param.comment
                }

                if(vc.$route.name == 'PublicTuningGuide') {
                    vc.params[index].setting.value = defaultValue.default
                    
                    if(vc.params[index].setting.hasOwnProperty('unit') && vc.params[index].setting.unit.length)
                        vc.params[index].setting.unit = defaultValue.unit
                    
                    vc.params[index].valid = true
                    
                    vc.storeTmpConfig()

                } else {
                    axios
                    .patch(process.env.VUE_APP_API_URL+'/configs/'+this.$route.params.id+'/postgresql.conf', {params: [p]}, {
                        headers: {
                            'Authorization': 'Bearer '+store.state.authToken
                        }
                    })
                    .then( function(response){
                        p['valid'] = true

                        vc.fetchData()

                    }).catch(function(err) {
                        console.log(err);
                    });
                }
            }
        },

        isValid( param ) {
            const p = this.params.find(p => ( param == p.name ));
            return ((typeof p === 'undefined') || p.valid)
        },

        isSet( param ) {
            const set = this.params.find(p => ( param == p.name ));
            return (typeof set !== 'undefined')
        },

        getDefaultValue( param ) {
            const def = this.defaultParams.find(p => ( param == p.name ));
            if ( (typeof def !== 'undefined') && def.hasOwnProperty('default'))
                return def.default
            else
                return 'noDefault'
        },

        setParam( index, custom = false, removeFocus = false) {

            const vc = this;

            if (vc.$route.name == 'ValidateConfig') {
                vc.forbiddenPopUp()
            } else if ( custom || (vc.editIndex != -1 ) ) {
                    var param = custom ? vc.newParam : vc.params[index];

                    if( vc.$route.name.includes('TuningGuide') ) {
                        param = {
                            name: vc.editName,
                            setting: {
                                value: vc.currentParam.setting.value,
                                ...( ( vc.currentParam.setting.hasOwnProperty('unit') &&  vc.currentParam.setting.unit.length) && ( { unit:  vc.currentParam.setting.unit }) ),
                            }
                        }
                    }
                        
                    if( (vc.editedParam.value !== param.setting.value) || (vc.editedParam.comment !== param.comment) || ( param.setting.hasOwnProperty('unit') && ( vc.editedParam.unit !== param.setting.unit) ) ) {
                        const p = {
                            name: param.name,
                            setting: {
                                value: param.setting.value,
                                ...( (param.setting.hasOwnProperty('unit')) && ( { unit: param.setting.unit }) ),
                            },
                            comment: param.comment,
                        }

                        if( vc.$route.name == 'PublicTuningGuide') {
                            vc.setParamByName(param.name)
                            vc.storeTmpConfig()
                        } else {
                            axios
                            .patch(process.env.VUE_APP_API_URL+'/configs/'+this.$route.params.id+'/postgresql.conf', {params: [p]}, {
                                headers: {
                                    'Authorization': 'Bearer '+store.state.authToken
                                }
                            })
                            .then( function(response){
                                //alert('Conf updated')
                                if(response.data.hasOwnProperty('error'))
                                    if(response.data.error.length && (response.data.inserted > 0))
                                        vc.notify('<p>There are some errors on the value specified for <strong><code>' + response.data.error.toString() + '</code></strong>. Mouse hover the error icon to see more details.</p>', false, 'error')
                                    else if (response.data.error.length && (response.data.inserted == 0))
                                        vc.notify('<p>There were some errors when trying to add <strong><code>' + response.data.error.toString() + '</code></strong> to your configuration. Please check your input and try again.</p>', false, 'error')

                                p['valid'] = true
                                vc.fetchData()

                                vc.toggleDiv('#custom-'+ param.name.replace('.','-') +' .savedParam', true)

                                setTimeout(function() {
                                    $('#custom-' + param.name.replace('.','-') + ' .savedParam').fadeOut()
                                },4000);

                                if(custom) {
                                    setTimeout(function() {
                                        $('#customParams').scrollTop($('#custom-'+param.name.replace('.','-'))[0].offsetTop - 20)
                                    },1000);
                                }
                            }).catch(function(err) {
                                console.log(err);
                            });
                        }
                    }

                    vc.editIndex = -1
                    vc.editName = ''
                    vc.currentParam, vc.editedParam = {"name":"","setting":{"":"","":""}
                }
            }
        },

        addParam( name = '', custom = false ) {
            const vc = this;

            if(vc.$route.name == 'ValidateConfig') {
                vc.forbiddenPopUp()
            } else if( vc.$route.name == 'PublicTuningGuide') { 
                
                var p = vc.getParamDefault(name)
                /* vc.editedParam = {
                    value: p.default,
                    comment: p.short,
                    unit: p.hasOwnProperty('unit') ? p.unit : ''
                } */

                vc.params.push({
                    name: name,
                    setting: {
                        value: p.hasOwnProperty('default') ? ( p.hasOwnProperty('unit') ? p.showDefault.split(' ')[0] : p.default) : '',
                        ...(p.hasOwnProperty('unit') && ( {unit: p.showDefault.split(' ')[1] }) )
                    },
                    valid: true
                })

                vc.storeTmpConfig()
            } else {
                if(name.length) {
                    var param = vc.defaultParams.find(p => (p.name == name));

                    if(typeof param !== 'undefined') {
                        const p = {
                            name: param.name,
                            setting: {
                                value: param.hasOwnProperty('default') ? param.default : '',
                            },
                            comment: param.short,
                        }

                        if(vc.$route.name == 'ConfigParams') {
                            vc.editedParam = {
                                value: p.setting.value,
                                comment: p.comment,
                                unit: ''
                            }
                        } else if(vc.$route.name == 'TuningGuide') {
                            vc.currentParam = {
                                value: p.setting.value,
                                ...( (p.setting.hasOwnProperty('unit')) && ( { unit: p.setting.unit }) ),
                            }
                        }

                        //console.log(this.params)

                        axios
                        .patch(process.env.VUE_APP_API_URL+'/configs/'+this.$route.params.id+'/postgresql.conf', {params: [p]}, {
                            headers: {
                                'Authorization': 'Bearer '+store.state.authToken
                            }
                        })
                        .then( function(response){
                            //alert('Conf updated')
                            //p['valid'] = true
                            //vc.params.push(p)
                            vc.editName = name
                            vc.fetchData(true)
                            //vc.editIndex = vc.params.length - 1
                        }).catch(function(err) {
                            console.log(err);
                        });

                    }

                } else {
                    if(!vc.newParam.hasOwnProperty('name')) {
                        vc.editIndex = -1
                        vc.editName = ''
                        vc.newParam = {
                            name: '',
                            setting: {
                                value: ''
                            },
                            comment: '',
                            valid: true
                        }
                    }
                    setTimeout(function() {
                        $('tr.newParam .name input').focus()
                        $('#customParams').scrollTop($("#customParams")[0].scrollHeight + 35)
                    },200);
                }
            }
        },

        removeParam: function( prop, index ) {
            if(vc.$route.name == 'ValidateConfig')
                vc.forbiddenPopUp()
            else
                this[prop].splice( index, 1 )
        },

        editParam(index, focusComment = false) {
            const vc = this;

            if(vc.$route.name != 'ValidateConfig') {

                vc.newParam = {}

                if(index == -1) {
                    vc.editName = ''
                    vc.editedParam = {}
                } else if(index != vc.editIndex) {

                    vc.setParam(vc.editIndex, false, true)

                    $('#tooltip').removeClass('show') // Hide comments tooltip if open
                    
                    if(vc.$route.name == 'ConfigParams') {
                        vc.editedParam = {
                            value: vc.params[index].setting.value,
                            comment: vc.params[index].comment,
                            unit: vc.params[index].setting.hasOwnProperty('unit') ? vc.params[index].setting.unit : ''
                        }
                        
                        vc.editName = vc.params[index].name
                    }
                }

                if(index !== -1) {
                    if(!focusComment) {
                        setTimeout(function(){
                            $('tr.edit .value .customValue').first().focus()
                        },150)
                    }

                    if(vc.$route.name !== 'ValidateConfig') {
                        const input = $(event.currentTarget);
                        input.parents('tr.base').find('.focus').removeClass('focus')
                        input.parents('td').addClass('focus')
                    } else if(index != vc.editIndex) {
                        vc.forbiddenPopUp()
                    }
                }
            } else if (index != -1)
                vc.forbiddenPopUp()

            vc.editIndex = index;

        },

        editParamByName(name) {
            const vc = this
            
            if( (!name.length) || (vc.editName == name) ) {
                vc.editName = ''
                vc.editedParam = {}
            } else if(vc.editName != name) {

                vc.params.forEach(function(param, index) {
                    if(param.name == name) {
                        vc.editIndex = index
                        return false
                    }
                })    

                $('#tooltip').removeClass('show') // Hide comments tooltip if open

                if(vc.isSet(name) && (vc.editIndex !== -1)) {
                    vc.editedParam = {
                        value: vc.params[vc.editIndex].setting.value,
                        comment: vc.params[vc.editIndex].comment,
                        unit: vc.params[vc.editIndex].setting.hasOwnProperty('unit') ? vc.params[vc.editIndex].setting.unit : ''
                    }

                    if(vc.$route.name.includes('TuningGuide')) {
                        vc.currentParam = {
                            name: name,
                            setting: {
                                value: vc.params[vc.editIndex].setting.value,
                                unit: vc.params[vc.editIndex].setting.hasOwnProperty('unit') ? vc.params[vc.editIndex].setting.unit : ''
                            }
                        }
                    }
                } else {
                    var p = this.getParamDefault(name)
                    vc.editedParam = {
                        value: p.default,
                        comment: '',
                        ...(p.hasOwnProperty('unit')  && ( {unit: p.unit} ))
                    }

                    if(vc.$route.name.includes('TuningGuide')) {
                        vc.currentParam = {
                            name: name,
                            setting: {
                                value: p.hasOwnProperty('default') ? ( p.hasOwnProperty('unit') ? p.showDefault.split(' ')[0] : p.default) : '',
                                ...(p.hasOwnProperty('unit')  && ( {unit: p.showDefault.split(' ')[1]} ))
                            }
                        }
                    }
                }

                vc.editName =  name
                
                setTimeout(function(){
                    $('tr.edit .value .customValue').first().focus()
                },150)

            }

        },

        setDefaultByName(name) {
            const vc = this

            vc.params.forEach(function(param, index) {
                if(param.name == name) {
                    vc.setDefault(index)
                    return false
                }
            }) 
        },

        toggleExpand(id, action) {
            var mainHeight = $('#main').innerHeight()
            var customHeight = $('#customParams').innerHeight()
            var defaultHeight = $('#defaultParams').innerHeight()

            if(action == 'collapse') {
                $('.splitPanel').css('height', 'calc(50% - 5px)').removeClass('expanded collapsed')
            } else {
                $(id).siblings('.splitPanel').css('height', '85px').removeClass('expanded').addClass('collapsed')
                $(id).height(mainHeight - 140).addClass('expanded').removeClass('collapsed')
            }

            this.showAutocompleteParam = false
        },

        cancelEdit(customParam = false) {
            const vc = this;

            if(vc.$route.name != 'ValidateConfig') {
                if(customParam) {
                    vc.newParam = {}
                } else if ( (vc.$route.name == 'ConfigParams') || vc.isSet(vc.editName)) {
                    vc.params[vc.editIndex].setting.value = vc.editedParam.value
                    vc.params[vc.editIndex].setting.unit = vc.editedParam.unit
                    vc.params[vc.editIndex].comment = vc.editedParam.comment
                }
            }
            vc.editParam(-1)
            vc.editName = ''
        },

        scrollTo(name) {
            $('#customParams').scrollTop($('#custom-'+name).offsetTop)
        },

        setAutoCompleteParam( param ) {
            this.newParam.name = param
            this.showAutocompleteParam = false
            $('#newParam').focus()
        },

        toggleAutocomplete() {
            let newParam = $('#newParam');
            if(newParam.is(':focus')) {
                $('ul.autoCompleteParam').css({
                    top: newParam.offset().top + newParam.height() + 4,
                    left: $('#app').hasClass('open') ? newParam.offset().left - 405 : newParam.offset().left - 5,
                })
                $('#customParams').scrollTop($("#customParams")[0].scrollHeight + 35)
                this.showAutocompleteParam = true
            } else {
                this.showAutocompleteParam = false
            }
        },

        checkAutoCompletePosition() {
            var elem = $('#customParams');
            if ((elem[0].scrollHeight - elem.scrollTop() - 45) < elem.outerHeight() && $('ul.autoCompleteParam').hasClass('show'))
                $('ul.autoCompleteParam').slideDown('fast')
            else if ((elem[0].scrollHeight - elem.scrollTop() - 45) > elem.outerHeight() && $('ul.autoCompleteParam').hasClass('show'))
                $('ul.autoCompleteParam').slideUp('fast')
        },

        selectAutoComplete(e) {
            var e = e || window.event;
            var active = $('ul.autoCompleteParam .active');

            if( (e.keyCode == '38') || (e.keyCode == '40') ) {
                e.preventDefault() // prevent scroll
                active.removeClass('active')

                if (e.keyCode == '38') //up
                   active = active.length ? (!active.is(':first-child') ? active.prev() : $('ul.autoCompleteParam li').last()) : $('ul.autoCompleteParam li').last()
                else if (e.keyCode == '40') //down
                   active = active.length ? (!active.is(':last-child') ? active.next() : $('ul.autoCompleteParam li').first() ) : $('ul.autoCompleteParam li').first()

                active.addClass('active').find('a').focus()
                $('ul.autoCompleteParam').scrollTop(active.scrollHeight)
            }

        },

        cleanupParams() {

            const vc = this

            // Cleanup config params for use on creation
            var params = JSON.parse(JSON.stringify(vc.params));

            params.forEach(function(item){
                delete item['valid']
                delete item['error']
            })
            
            return params
        },

        storeTmpConfig() {
            const vc = this;

            sessionStorage.tmpConfig = JSON.stringify({
                name: $('span.configName').text() + ( (vc.$route.name == 'PublicConfigParams') ? ' (cloned)' : ''),
                params: vc.cleanupParams(),
                pgVersion: vc.pgVersion
            })
        },

        cloneConfig() {
            const vc = this;

            if(!store.state.authToken.length) {
                sessionStorage.latestComponent = 'PublicConfigParams'

                vc.storeTmpConfig()

                this.popUp('Attention','<p>Please <a href="' + this.loginUrl + '">login</a> or <a href="' + this.loginUrl + '">signup</a> to clone this configuration</p>')
            } else {
                axios
                .post(process.env.VUE_APP_API_URL+'/configs', {
                        name: $('span.configName').text(),
                        pgVersion: vc.pgVersion
                    },
                    {
                        headers: {
                            'Authorization': 'Bearer '+store.state.authToken
                        }
                    }
                )
                .then( function(response){ // Add postgresql.conf file
                    const configId = response.data.configId;

                    axios
                    .put(process.env.VUE_APP_API_URL+'/configs/'+configId+'/postgresql.conf', {
                        headers: {
                            'Authorization': 'Bearer '+store.state.authToken,
                            'accept': '*/*',
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    })
                    .then( function(response){ // Adding config params to file
                        axios
                        .patch(process.env.VUE_APP_API_URL+'/configs/'+configId+'/postgresql.conf', {params: vc.params}, {
                            headers: {
                                'Authorization': 'Bearer '+store.state.authToken
                            }
                        })
                        .then( function(response){
                            router.push('/manage/config/'+configId)
                            vc.notify('<p>Configuration cloned successfuly.</p>')
                        }).catch(function(err) {
                            console.log(err);
                        });
                    }).catch(function(err) {
                        console.log(err);
                    });

                }).catch(function(err) {
                    console.log(err);
                });
            }

        }
    }
}